import React from "react";
import SideNav from "../components/SideNav/sideNav";
import Header from "../components/Header/hearder";
import { Wrapper } from "./layout.styles";
import ObjectUsers from "../components/pages/Tenants/objectUsers";

const ObjectUsersLayout = () => {
  return (
    <React.Fragment>
      <Header />
      <Wrapper>
        <SideNav />
        <div style={{ margin: "70px 0px 0px 200px", width: "100%" }}>
          <ObjectUsers />
        </div>
      </Wrapper>
    </React.Fragment>
  );
};

export default ObjectUsersLayout;
